export default __webpack_public_path__ + "static/media/pinkSquareCrownToRight.ef69ce22.svg";